<template>
  <div>
    <div
      v-loading.fullscreen.lock="loading"
      element-loading-text="挖填方计算中,请稍后"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    ></div>
    <layout v-if="mapready"></layout>
  </div>
</template>

<script>
import layout from "@/components/layout/layout";
import { Controller } from "../mapfunction/Controller.js";

export default {
  name: "home",
  data() {
    return {
      data: [],
      mapready: false,
      loading: false,
    };
  },
  methods: {},
  mounted() {
    window.globe = new map3d.Globe(
      "cesiumContainer",
      null,
      null,
      false,
      "ThreeContainer",
      Cesium
    );
    map3d_viewer.viewer.scene.globe.depthTestAgainstTerrain = true;
    Cesium.Ion.defaultAccessToken =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI5MmFmYTY5Mi0yOTczLTQ5NjMtODlhMS1hNmNmZTdjNjA1Y2MiLCJpZCI6MzgxMjMsImlhdCI6MTYwNTk2MzQ2Nn0.d7IKmtQQsQI14ci1LxnXb4LOTMSwucxzqgBixJJ2I-k";
    new Controller();
    this.mapready = true;
    map3d_viewer.viewer.mouseHandlerManager.listen("loading", (loading) => {
      this.loading = loading;
    });
    map3d_viewer.viewer.mouseHandlerManager.trigger("loadBuilding", true);
    map3d_viewer.viewer.mouseHandlerManager.trigger("loadPOI", true);
    map3d.Camera.CameraAdjustment.flyTo(
      window.viewCameraConfig.position[0],
      window.viewCameraConfig.position[1],
      window.viewCameraConfig.height,
      window.viewCameraConfig.time
    );
  },
  components: {
    layout: layout,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue